import { render, staticRenderFns } from "./Clear.vue?vue&type=template&id=7f20d13d&scoped=true"
import script from "./Clear.vue?vue&type=script&lang=js"
export * from "./Clear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f20d13d",
  null
  
)

export default component.exports